import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { manchiApi, manchiAuth } from "@/lib/manchiApi";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Sparkles, Lock, Loader2, Heart } from "lucide-react";
import { toast } from "sonner";

export default function ManchiLogin() {
  const nav = useNavigate();
  const [passkey, setPasskey] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (manchiAuth.getToken()) {
      manchiApi.get("/me").then(() => nav("/manchi/studio", { replace: true })).catch(() => manchiAuth.clear());
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    if (!passkey.trim()) return;
    setBusy(true);
    try {
      const { data } = await manchiApi.post("/auth", { passkey });
      manchiAuth.saveToken(data.token);
      toast.success(`Welcome back to ${data.agent_name} ✨`);
      nav("/manchi/studio", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid passcode");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4"
      style={{ background: "radial-gradient(1200px 600px at 20% 0%, #ffe4ef 0%, #fff5f9 45%, #fdf2f8 100%)" }}>
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-3xl bg-gradient-to-br from-pink-400 to-rose-500 flex items-center justify-center shadow-lg shadow-pink-300/50 mb-4">
            <Heart className="w-8 h-8 text-white" fill="white" />
          </div>
          <h1 className="text-4xl font-black tracking-tight text-rose-900" data-testid="manchi-login-title">ManchiGirl</h1>
          <p className="text-rose-500 text-sm mt-2 text-center max-w-xs">
            Your daily Economics &amp; Finance LinkedIn studio — worldwide news, one polished post a day.
          </p>
        </div>

        <form onSubmit={submit} className="bg-white/80 backdrop-blur rounded-3xl border border-pink-100 shadow-xl shadow-pink-200/40 p-7">
          <label className="text-xs font-semibold uppercase tracking-widest text-rose-400 flex items-center gap-2 mb-2">
            <Lock className="w-3.5 h-3.5" /> Passcode
          </label>
          <Input
            type="password"
            value={passkey}
            onChange={(e) => setPasskey(e.target.value)}
            placeholder="Enter your passcode"
            data-testid="manchi-passcode-input"
            className="rounded-2xl border-pink-200 focus-visible:ring-pink-400 bg-pink-50/50 h-12 text-rose-900"
          />
          <Button
            type="submit"
            disabled={busy}
            data-testid="manchi-login-btn"
            className="w-full mt-5 h-12 rounded-2xl bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white font-semibold shadow-lg shadow-pink-300/40"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Sparkles className="w-4 h-4 mr-2" />}
            {busy ? "Unlocking…" : "Enter studio"}
          </Button>
        </form>
      </div>
    </div>
  );
}
